import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import {
  BASE_PATHS,
  BREAKPOINTS_WIDTHS,
  PATHS,
  useWindowSize,
} from '@belong/common';
import { FoundersFeedbackCard, Link, LinkBase, Text } from '@belong/ui';
import HeaderMain from 'components/HeaderMain/HeaderMain';
import { RouterHeaderNavLink } from 'components/HeaderMain/RouterHeaderNavLink/RouterHeaderNavLink';
import { DEFAULT_LINKS } from 'consts/links';
import AccountHeaderContainer from 'containers/AccountHeaderContainer/AccountHeaderContainer';
import { ContactUs } from 'containers/ContactUs/ContactUs';
import PropTypes from 'prop-types';
import { selectUser } from 'store/redux/user/selectors';

const WHITE_TEXT_CLASS = 'text-white';
const WHITE_TEXT_PATHS = [
  BASE_PATHS.LEASE_SIGNING,
  PATHS.LEASE_SIGNING_FLOW_V2,
  '/invitation',
];

const HeaderContainer = ({
  headerMainProps,
  location: { pathname },
  ...rest
}) => {
  const user = useSelector(selectUser);
  const { width } = useWindowSize();
  const isMobile = width < BREAKPOINTS_WIDTHS.LG;

  const isTextWhite = WHITE_TEXT_PATHS.some((path) => pathname.includes(path))
    ? WHITE_TEXT_CLASS
    : '';

  return (
    <HeaderMain
      {...headerMainProps}
      navigationComponents={
        headerMainProps?.navigationComponents || [
          ...(!isMobile
            ? [
                <div className="mr-sm flex" key="homeowners">
                  <LinkBase href={BASE_PATHS.HOMEOWNER}>
                    <Text
                      variant="p1"
                      fontWeight="semibold"
                      className={isTextWhite}
                    >
                      FOR HOMEOWNERS
                    </Text>
                  </LinkBase>
                </div>,
                <div className="flex" key="residents">
                  <LinkBase href={BASE_PATHS.HOME}>
                    <Text
                      variant="p1"
                      fontWeight="semibold"
                      className={isTextWhite}
                    >
                      FOR RESIDENTS
                    </Text>
                  </LinkBase>
                </div>,

                <RouterHeaderNavLink
                  label={DEFAULT_LINKS.HOW_IT_WORKS.label}
                  to={`${pathname}?activeModal=HOW_IT_WORKS`}
                  selected={`${pathname}?activeModal=HOW_IT_WORKS` === pathname}
                  key={DEFAULT_LINKS.HOW_IT_WORKS.id}
                  theme={headerMainProps?.theme}
                  className={isMobile && 'font-semibold'}
                />,
              ]
            : [
                <div className="mb-xl" key="homeowners">
                  <Link href={BASE_PATHS.HOMEOWNER}>
                    <Text
                      className="text-navy"
                      fontWeight="semibold"
                      variant="h3"
                    >
                      FOR HOMEOWNERS
                    </Text>
                  </Link>
                </div>,
                <div className="mb-xl" key="residents">
                  <Link href={BASE_PATHS.HOME}>
                    <Text
                      className="text-navy"
                      fontWeight="semibold"
                      variant="h3"
                    >
                      FOR RESIDENTS
                    </Text>
                  </Link>
                </div>,
                <div key={DEFAULT_LINKS.HOW_IT_WORKS.id} className="mb-xl">
                  <Link href={`${pathname}?activeModal=HOW_IT_WORKS`}>
                    <Text
                      className="text-navy"
                      fontWeight="semibold"
                      variant="h3"
                    >
                      {DEFAULT_LINKS.HOW_IT_WORKS.label}
                    </Text>
                  </Link>
                </div>,
              ]),
          <ContactUs
            key="ContactUs"
            dropdownMenu
            isMobile={isMobile}
            className={isTextWhite}
          />,
          <AccountHeaderContainer
            key="AccountHeaderContainer"
            theme={headerMainProps?.theme}
          />,
          // This array also feeds the desktop nav row, hence the isMobile gate.
          ...(isMobile && user
            ? [
                <div className="mt-xl pb-xl" key="foundersFeedback">
                  <FoundersFeedbackCard name="founders_feedback_burger_menu_legacy" />
                </div>,
              ]
            : []),
        ]
      }
      {...rest}
    />
  );
};

HeaderContainer.propTypes = {
  headerMainProps: PropTypes.object,
  location: PropTypes.object.isRequired,
};

HeaderContainer.defaultProps = {
  headerMainProps: null,
};

/** @type {React.ComponentType<any>} */
const HeaderContainerWithRouter = withRouter(HeaderContainer);

export default HeaderContainerWithRouter;
